import { ChatsWithNewMessagesActionInterface, StateInterface } from "../interfaces/chasWithNewMessagesInterface";

export const TYPES = {
    ADD: "TYPE/ADD",
    REMOVE: "TYPE/REMOVE"
}

const initialState: StateInterface = {
    list: []
}

export default function (state = initialState, action: ChatsWithNewMessagesActionInterface){
    switch(action.type){
        case TYPES.ADD: {
            if(state.list.includes(action.payload)){
                return {
                    ...state
                }
            }
            
            else {
                return {
                    ...state,
                    list: [
                        ...state.list,
                        action.payload
                    ]
                }
            }
        }
        
        case TYPES.REMOVE: {
            const index = state.list.indexOf(action.payload);
            let newState = state.list;
            
            newState.splice(index, 1);

            return {
                ...state,
                list: newState
            }
        }
        
        default: return {
            ...state
        }
    }

}